export enum ParamField {
    Global = 'q',
    Semantic = 'sq',
    FullText = 'ftq',
    Facets = 'f',
    AdvancedSearch = 'advQ',
    Fields = 'fields',
    Page = 'page',
    PageSize = 'pageSize',
    Sort = 'sort',
    View = 'view'
}

export type UrlQueryParams = Partial<{
    [key in ParamField]: string | undefined;
}>;
